import React from 'react';
import Select from "react-select";
import {customStyles} from "../helpers/style";
import {input} from "../translate";
function HistorySelect({ handleChange, query, select, isDisabled = false }) {
    return (
        <Select
            isDisabled={isDisabled}
            styles={customStyles}
            menuPlacement="auto"
            menuPosition="fixed"
            onChange={(ev) => handleChange('caller', {target:ev})}
            menuPortalTarget={document.body}
            className="basic-single w-100"
            classNamePrefix="select"
            isSearchable={true}
            value={{ value: select?.find(s => s.number === query?.caller)?.number || '' ,label: select?.find(s => s.number === query?.caller)? (select?.find(s => s.number === query?.caller)?.number || '') + ' ' + (select?.find(s => s.number === query?.caller)?.context || ''):input.select[+localStorage.getItem('atsLang')  || 1]}}
            name="color"
            options={[{number: '', label: input.select[+localStorage.getItem('atsLang')  || 1]},...(select || []).map(s => ({
                value: s.number,
                label: s.number + ' ' + (s.context || '')
            }))]}
                            />
    );
}

export default HistorySelect;